import { createDraftSafeSelector } from '@reduxjs/toolkit';

import { RootState } from '@app/redux/interface';

export const getPublicSettingsState = (state: RootState) => state.publicSettings;

export const getIsEmailValidationEnabled = createDraftSafeSelector(
	getPublicSettingsState,
	publicSettings => publicSettings.isEmailsAllowlistEnabled || publicSettings.isEmailsBlocklistEnabled,
);
